// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-slider-button {
  min-width: 5.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  background: rgb(65 65 65 / 55%);
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  padding: 0.8rem;
  cursor: pointer;
}

.image-slider-button:hover {
  background: rgb(65 65 65 / 75%);
}

.event-datetime-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #555;
  font-size: 13px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.15s ease-in-out;
  cursor: pointer;
  background-color: transparent;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.event-datetime-badge:hover,
.event-datetime-badge:focus-visible {
  background-color: #ebedeb;
  color: #115061;
}

.event-datetime-badge:active {
  transform: scale(0.95);
}

.event-datetime-text {
  display: inline;
  white-space: nowrap;
}

/* Dynamic compact mode (when space is constrained) */
.event-datetime-badge.compact {
  padding: 6px;
  border-radius: 50%;
  background-color: #ebedeb;
  color: #444;
}

.event-datetime-badge.compact:hover,
.event-datetime-badge.compact:focus-visible {
  background-color: #dfe2df;
  color: #115061;
}

.event-datetime-badge.compact:active {
  transform: scale(0.92);
}

.event-datetime-badge.compact .event-datetime-text {
  display: none;
}

/* Fallback for ultra-narrow mobile viewports */
@media (max-width: 600px) {
  .event-datetime-text {
    display: none;
  }
  .event-datetime-badge {
    padding: 6px;
    border-radius: 50%;
    background-color: #ebedeb;
    color: #444;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Events/ViewEventsModal.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B;4EAC0E;EAC1E,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,6BAA6B;EAC7B,yBAAiB;UAAjB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA,+CAA+C;AAC/C;EACE;IACE,aAAa;EACf;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;EACb;AACF","sourcesContent":[".image-slider-button {\n  min-width: 5.2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  background: rgb(65 65 65 / 55%);\n  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),\n    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n  padding: 0.8rem;\n  cursor: pointer;\n}\n\n.image-slider-button:hover {\n  background: rgb(65 65 65 / 75%);\n}\n\n.event-datetime-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #555;\n  font-size: 13px;\n  font-weight: 500;\n  padding: 4px 8px;\n  border-radius: 6px;\n  transition: all 0.15s ease-in-out;\n  cursor: pointer;\n  background-color: transparent;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.event-datetime-badge:hover,\n.event-datetime-badge:focus-visible {\n  background-color: #ebedeb;\n  color: #115061;\n}\n\n.event-datetime-badge:active {\n  transform: scale(0.95);\n}\n\n.event-datetime-text {\n  display: inline;\n  white-space: nowrap;\n}\n\n/* Dynamic compact mode (when space is constrained) */\n.event-datetime-badge.compact {\n  padding: 6px;\n  border-radius: 50%;\n  background-color: #ebedeb;\n  color: #444;\n}\n\n.event-datetime-badge.compact:hover,\n.event-datetime-badge.compact:focus-visible {\n  background-color: #dfe2df;\n  color: #115061;\n}\n\n.event-datetime-badge.compact:active {\n  transform: scale(0.92);\n}\n\n.event-datetime-badge.compact .event-datetime-text {\n  display: none;\n}\n\n/* Fallback for ultra-narrow mobile viewports */\n@media (max-width: 600px) {\n  .event-datetime-text {\n    display: none;\n  }\n  .event-datetime-badge {\n    padding: 6px;\n    border-radius: 50%;\n    background-color: #ebedeb;\n    color: #444;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
